import { Body, Heading, Icon } from '@assembly-js/design-system';
import { useTranslation } from 'react-i18next';

import { useElectronUpdateStatus } from 'src/features/electron/ElectronUpdateContext';
import { getElectronAPI } from 'src/hooks/useElectron';

export function SidebarUpdateCard() {
  const { t } = useTranslation();
  const { status } = useElectronUpdateStatus();
  const api = getElectronAPI();

  if (!api || status !== 'ready') {
    return null;
  }

  return (
    <button
      className="w-full hover:cursor-pointer bg-white border border-gray-200 rounded-lg p-2 py-1.5 flex flex-row items-center gap-2"
      onClick={() => api.installUpdate()}
    >
      <div className="flex items-center justify-center rounded-md bg-gray-100 p-1.5">
        <Icon icon="Repeat" className="h-4 w-4" />
      </div>
      <div className="flex flex-col w-full items-start">
        <Heading size="xs" className="text-black-heading">
          {t(($) => $.desktop_app.update_toast.title)}
        </Heading>
        <Body className="text-secondary text-[10px]">
          {t(($) => $.desktop_app.update_toast.description)}
        </Body>
      </div>
    </button>
  );
}
